export class GTMService {
    public static $inject: string[] = [
        "$window"
    ];

    constructor(
        private $window: ng.IWindowService
    ) {}

    public sendPageView({name, path}) {
        this.send({
            event: "Page View",
            routeName: name,
            pageUrl: path,
            pageTitle: (typeof document !== "undefined" && document.title) || ""
        });
    }

    private send(data: any) {
        this.$window.dataLayer.push(data);
    }
}
